// src/admin/AdminLogin.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const C = {
  dark:  "#0f172a",
  dark2: "#1e293b",
  gold:  "#f5c518",
  goldD: "#d4a80f",
  white: "#ffffff",
  gray:  "#94a3b8",
  red:   "#ef4444",
};

// ── Hard-coded admin credentials ──────────────────────────────────────────────
const ADMIN_CREDENTIALS = [
  { username: "admin",    password: "admin123",    name: "Super Admin"   },
  { username: "HaloSorath", password: "HaloSorath@123",name: "HaloSorath Admin" },
];

const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPass,  setShowPass]  = useState(false);
  const [error,     setError]     = useState("");
  const [loading,   setLoading]   = useState(false);
  const [shake,     setShake]     = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    setError("");

    if (!username.trim() || !password.trim()) {
      setError("Please enter both username and password.");
      triggerShake();
      return;
    }

    const match = ADMIN_CREDENTIALS.find(
      c => c.username === username.trim() && c.password === password.trim()
    );

    if (!match) {
      setError("Invalid username or password. Please try again.");
      triggerShake();
      return;
    }

    setLoading(true);
    // Store login state
    sessionStorage.setItem("adminLoggedIn", "true");
    sessionStorage.setItem("adminName", match.name);

    setTimeout(() => {
      navigate("/admin/dashboard");
    }, 900);
  };

  const triggerShake = () => {
    setShake(true);
    setTimeout(() => setShake(false), 500);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800;900&family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');

        @keyframes fadeUp  { from{opacity:0;transform:translateY(24px)} to{opacity:1;transform:translateY(0)} }
        @keyframes pulse   { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:.5;transform:scale(1.3)} }
        @keyframes shake   { 0%,100%{transform:translateX(0)} 20%,60%{transform:translateX(-8px)} 40%,80%{transform:translateX(8px)} }
        @keyframes spin    { to{transform:rotate(360deg)} }
        @keyframes float   { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-8px)} }
        @keyframes gradBG  { 0%{background-position:0% 50%} 50%{background-position:100% 50%} 100%{background-position:0% 50%} }

        * { box-sizing:border-box; margin:0; padding:0; }
        body { font-family:'Plus Jakarta Sans',sans-serif; }

        .login-input {
          width:100%; padding:14px 16px 14px 46px;
          background:rgba(255,255,255,.06);
          border:1.5px solid rgba(255,255,255,.12);
          border-radius:12px; color:#fff; font-size:14px;
          font-family:'Plus Jakarta Sans',sans-serif;
          outline:none; transition:border-color .2s, box-shadow .2s;
        }
        .login-input::placeholder { color:rgba(255,255,255,.3); }
        .login-input:focus {
          border-color:#f5c518;
          box-shadow:0 0 0 4px rgba(245,197,24,.12);
          background:rgba(255,255,255,.09);
        }
        .login-btn {
          width:100%; padding:15px;
          background:linear-gradient(135deg,#f5c518,#d4a80f);
          border:none; border-radius:12px;
          color:#0f172a; font-size:16px; font-weight:800;
          font-family:'Playfair Display',serif;
          cursor:pointer; transition:all .25s;
          letter-spacing:.4px;
        }
        .login-btn:hover:not(:disabled) {
          transform:translateY(-2px);
          box-shadow:0 10px 32px rgba(245,197,24,.45);
        }
        .login-btn:disabled { opacity:.6; cursor:not-allowed; }
        .shake { animation:shake .4s ease; }

        .hint-row { display:flex; align-items:center; gap:8px; padding:9px 14px; background:rgba(255,255,255,.04); border:1px solid rgba(255,255,255,.08); border-radius:8px; margin-bottom:6px; }
        .hint-key { background:rgba(245,197,24,.15); border:1px solid rgba(245,197,24,.3); border-radius:6px; padding:2px 9px; font-size:12px; color:#f5c518; font-family:monospace; font-weight:700; }
      `}</style>

      <div style={{
        minHeight:"100vh", display:"flex", alignItems:"center", justifyContent:"center",
        background:"linear-gradient(135deg,#0f172a 0%,#1a1a2e 40%,#0d1b35 70%,#0f172a 100%)",
        backgroundSize:"400% 400%", animation:"gradBG 12s ease infinite",
        padding:16, fontFamily:"'Plus Jakarta Sans',sans-serif",
        position:"relative", overflow:"hidden",
      }}>

        {/* Decorative blobs */}
        <div style={{ position:"absolute", top:-120, right:-120, width:400, height:400, borderRadius:"50%", background:"rgba(245,197,24,.06)", pointerEvents:"none" }} />
        <div style={{ position:"absolute", bottom:-80, left:-80, width:300, height:300, borderRadius:"50%", background:"rgba(245,197,24,.04)", pointerEvents:"none" }} />
        <div style={{ position:"absolute", top:"30%", left:"5%", width:180, height:180, borderRadius:"50%", background:"rgba(59,130,246,.04)", pointerEvents:"none" }} />

        {/* Floating car emoji */}
        <div style={{ position:"absolute", top:40, right:60, fontSize:36, opacity:.12, animation:"float 4s ease-in-out infinite", pointerEvents:"none" }}>🚗</div>
        <div style={{ position:"absolute", bottom:60, left:40, fontSize:28, opacity:.1, animation:"float 6s ease-in-out infinite", pointerEvents:"none" }}>🚐</div>

        {/* Card */}
        <div className={shake ? "shake" : ""} style={{
          background:"rgba(255,255,255,.04)", backdropFilter:"blur(20px)",
          border:"1px solid rgba(255,255,255,.08)",
          borderRadius:28, padding:"44px 40px",
          width:"100%", maxWidth:420,
          boxShadow:"0 32px 80px rgba(0,0,0,.5), 0 0 0 1px rgba(255,255,255,.05) inset",
          animation:"fadeUp .6s ease",
        }}>

          {/* Logo */}
          <div style={{ textAlign:"center", marginBottom:32 }}>
            <div style={{ width:60, height:60, borderRadius:18, background:"linear-gradient(135deg,#f5c518,#d4a80f)", display:"flex", alignItems:"center", justifyContent:"center", fontSize:28, fontWeight:900, color:"#0f172a", margin:"0 auto 16px", boxShadow:"0 8px 24px rgba(245,197,24,.35)" }}>M</div>
            <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:28, fontWeight:900, color:"#fff", marginBottom:4, letterSpacing:"-0.5px" }}>
              <span style={{ color:"#f5c518" }}>Hale</span>Sorath
            </h1>
            <p style={{ fontSize:13, color:"rgba(255,255,255,.4)", letterSpacing:"1.5px", textTransform:"uppercase" }}>Secure Access Portal</p>
          </div>

          {/* Live badge */}
          <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:7, marginBottom:28, background:"rgba(245,197,24,.07)", border:"1px solid rgba(245,197,24,.2)", borderRadius:50, padding:"7px 18px" }}>
            <span style={{ width:6, height:6, background:"#22c55e", borderRadius:"50%", animation:"pulse 1.8s ease-in-out infinite", flexShrink:0 }} />
            <span style={{ fontSize:11, color:"rgba(255,255,255,.5)", fontWeight:600, letterSpacing:"1px", textTransform:"uppercase" }}>Admin Panel Live</span>
          </div>

          {/* Form */}
          <form onSubmit={handleLogin}>
            {/* Username */}
            <div style={{ marginBottom:16 }}>
              <label style={{ display:"block", fontSize:11, fontWeight:700, color:"rgba(255,255,255,.5)", letterSpacing:"1px", textTransform:"uppercase", marginBottom:8 }}>Username</label>
              <div style={{ position:"relative" }}>
                <span style={{ position:"absolute", left:14, top:"50%", transform:"translateY(-50%)", fontSize:17, pointerEvents:"none" }}>👤</span>
                <input
                  type="text"
                  className="login-input"
                  placeholder="Enter your username"
                  value={username}
                  onChange={e => { setUsername(e.target.value); setError(""); }}
                  autoComplete="username"
                />
              </div>
            </div>

            {/* Password */}
            <div style={{ marginBottom:8 }}>
              <label style={{ display:"block", fontSize:11, fontWeight:700, color:"rgba(255,255,255,.5)", letterSpacing:"1px", textTransform:"uppercase", marginBottom:8 }}>Password</label>
              <div style={{ position:"relative" }}>
                <span style={{ position:"absolute", left:14, top:"50%", transform:"translateY(-50%)", fontSize:17, pointerEvents:"none" }}>🔒</span>
                <input
                  type={showPass ? "text" : "password"}
                  className="login-input"
                  placeholder="Enter your password"
                  value={password}
                  onChange={e => { setPassword(e.target.value); setError(""); }}
                  autoComplete="current-password"
                />
                <button type="button" onClick={() => setShowPass(s => !s)}
                  style={{ position:"absolute", right:14, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", fontSize:17, lineHeight:1, color:"rgba(255,255,255,.4)", padding:0 }}>
                  {showPass ? "🙈" : "👁️"}
                </button>
              </div>
            </div>

            {/* Error */}
            {error && (
              <div style={{ background:"rgba(239,68,68,.1)", border:"1px solid rgba(239,68,68,.3)", borderRadius:10, padding:"10px 14px", fontSize:13, color:"#fca5a5", marginBottom:16, display:"flex", alignItems:"center", gap:8 }}>
                <span>⚠️</span> {error}
              </div>
            )}

            {/* Submit */}
            <button type="submit" className="login-btn" disabled={loading} style={{ marginTop:error?0:20 }}>
              {loading
                ? <span style={{ display:"inline-flex", alignItems:"center", gap:10 }}>
                    <span style={{ display:"inline-block", width:18, height:18, border:"2.5px solid rgba(15,23,42,.4)", borderTopColor:"#0f172a", borderRadius:"50%", animation:"spin .7s linear infinite" }} />
                    Signing in…
                  </span>
                : "🔐 Sign In to Admin"
              }
            </button>
          </form>

          {/* Hint credentials
          <div style={{ marginTop:28 }}>
            <p style={{ fontSize:11, color:"rgba(255,255,255,.3)", textAlign:"center", marginBottom:10, letterSpacing:".5px", textTransform:"uppercase" }}>Demo Credentials</p>
            <div className="hint-row">
              <span style={{ fontSize:12, color:"rgba(255,255,255,.35)", flex:1 }}>Username</span>
              <span className="hint-key">admin</span>
              <span style={{ fontSize:12, color:"rgba(255,255,255,.2)" }}>|</span>
              <span className="hint-key">HaloSorath</span>
            </div>
            <div className="hint-row">
              <span style={{ fontSize:12, color:"rgba(255,255,255,.35)", flex:1 }}>Password</span>
              <span className="hint-key">admin123</span>
              <span style={{ fontSize:12, color:"rgba(255,255,255,.2)" }}>|</span>
              <span className="hint-key">HaloSorath@123</span>
            </div>
          </div> */}

          {/* Back to site */}
          <div style={{ textAlign:"center", marginTop:24 }}>
            <a href="/" style={{ fontSize:13, color:"rgba(255,255,255,.3)", textDecoration:"none", transition:"color .2s" }}
              onMouseEnter={e=>e.target.style.color="#f5c518"}
              onMouseLeave={e=>e.target.style.color="rgba(255,255,255,.3)"}>
              ← Back to HaloSorath Website
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLogin;